/* @flow */

import * as React from 'react';
import styled from '@emotion/styled';

type Props = {
  name: string
};

const Message = styled.div(({ theme }) => ({
  color: theme.color.basis2,
  display: 'flex',
  fontSize: theme.fontSize.small,
  margin: 'auto',
  padding: theme.spacing.default
}));

function NoHistory({ name }: Props) {
  return <Message>{name} has no history</Message>;
}

export default NoHistory;
